import { Link } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { IDR, imgUrl } from "@/lib/api";
import { Trash2 } from "lucide-react";

const PLACE = "https://images.unsplash.com/photo-1503341504253-dff4815485f1?crop=entropy&cs=srgb&fm=jpg";

export default function Cart() {
  const { items, update, remove, subtotal } = useCart();
  const empty = items.length === 0;

  return (
    <div className="max-w-[1200px] mx-auto px-4 sm:px-8 py-10">
      <h1 className="display text-5xl md:text-7xl mb-8">KERANJANG</h1>
      {empty ? (
        <div data-testid="cart-empty" className="border border-[color:var(--border)] p-16 text-center text-neutral-400">
          <p>Keranjang kamu masih kosong.</p>
          <Link to="/shop" className="inline-block mt-6 bg-white text-black px-8 py-3 text-xs tracking-widest">MULAI BELANJA</Link>
        </div>
      ) : (
        <div className="grid lg:grid-cols-[1fr,380px] gap-10">
          <div className="border-t border-[color:var(--border)]">
            {items.map((it, i) => (
              <div key={i} data-testid={`cart-item-${i}`} className="grid grid-cols-[80px,1fr,auto] gap-4 py-6 border-b border-[color:var(--border)] items-center">
                <img src={imgUrl(it.image) || PLACE} alt={it.name} className="w-20 h-24 object-cover" />
                <div className="min-w-0">
                  <div className="text-[10px] tracking-widest text-neutral-500">{it.article_code}</div>
                  <div className="display text-2xl">{it.name}</div>
                  <div className="text-xs text-neutral-400 mt-1">{it.color} · {it.size}</div>
                  <div className="mt-2 inline-flex hairline text-sm">
                    <button data-testid={`dec-${i}`} onClick={() => update(i, it.qty - 1)} className="w-8 h-8">−</button>
                    <span className="w-10 h-8 flex items-center justify-center border-x border-[color:var(--border)]">{it.qty}</span>
                    <button data-testid={`inc-${i}`} onClick={() => update(i, it.qty + 1)} className="w-8 h-8">+</button>
                  </div>
                </div>
                <div className="text-right">
                  <div className="tabular-nums">{IDR(it.price * it.qty)}</div>
                  <button data-testid={`remove-${i}`} onClick={() => remove(i)} className="mt-2 text-neutral-500 hover:text-[color:var(--accent)]"><Trash2 size={16} strokeWidth={1.25} /></button>
                </div>
              </div>
            ))}
          </div>

          <aside className="border border-[color:var(--border)] p-6 h-fit sticky top-24">
            <div className="text-[10px] tracking-widest text-neutral-500 mb-4">RINGKASAN</div>
            <div className="flex justify-between text-sm py-2"><span>Subtotal</span><span data-testid="subtotal" className="tabular-nums">{IDR(subtotal)}</span></div>
            <div className="flex justify-between text-sm py-2 text-neutral-400"><span>Ongkir</span><span>Dihitung saat checkout</span></div>
            <div className="border-t border-[color:var(--border)] my-3" />
            <div className="flex justify-between display text-2xl"><span>TOTAL</span><span className="tabular-nums">{IDR(subtotal)}</span></div>
            <Link to="/checkout" data-testid="checkout-btn" className="mt-6 block text-center bg-white text-black py-4 text-xs tracking-widest hover:bg-neutral-200">CHECKOUT</Link>
          </aside>
        </div>
      )}
    </div>
  );
}
